<div class="hatfield-popover-overlay" *ngIf="visible" (click)="dismiss()">
	<div class="hatfield-popover" (click)="$event.stopPropagation()">
		<div class="content">
			<h2 class="prize-heading">WIN R50 000 in cash</h2>
			<p class="prize-subheading">Book your unit today and be amongst one of the first {{goalCustomers}} customers to WIN BIG!</p>

			<div class="progress">
				<div class="progress-labels">
					<span class="progress-title">Competition Progress</span>
					<span class="progress-count">{{activeCustomers}} of {{goalCustomers}}</span>
				</div>
				<div class="progress-row">
					<div class="progress-track">
						<div class="progress-fill" [style.width.%]="progressPercent">
							<span class="progress-thumb">
								<img src="/assets/iconTruckProgress.svg" alt="">
							</span>
						</div>
					</div>
				</div>
				<div class="progress-ticks-row">
					<div class="progress-ticks">
						<span>Start</span>
						<span>25%</span>
						<span>50%</span>
						<span>75%</span>
						<span>Goal</span>
					</div>
				</div>
			</div>

			<p class="terms">
				<span class="terms-label">Ts &amp; Cs:</span> To qualify, you must rent a unit from our official opening and remain a paying customer until the draw. The draw will take place once we have achieved {{goalCustomers}} active customers. The winner will be notified via email and phone. If no response is received in the first 24hrs, the draw will run again.
			</p>

			<button class="view-units-btn" (click)="dismiss()">View units</button>
		</div>
	</div>
</div>
